import React from "react";
import { Col, Button, Icon } from "antd";
import {
  REPORT,
  GAPANALYSIS,
  ANALYSIS,
  DRIVERS
} from "../../modules/results/constants";
const intl = {
  analysisBtn: {
    en: "Go to analysis",
    dk: "Gå til analyse"
  },
  reportBtn: {
    en: "Go to report",
    dk: "Gå til rapport"
  },
  gapBtn: {
    en: "Go to Gap analysis",
    dk: "Gå til Gap analyse"
  },
  driverBtn: {
    en: "Go to Drivers",
    dk: "Gå til Drivere"
  }
};

function Navigation(props) {
  const isNotDisabled = props.result ? props.result[0] : {};

  let button;
  const type = window.location.pathname.split("/")[1];
  switch (type) {
    case "360":
      button = (
        <Button
          disabled={!isNotDisabled["peer1"]}
          key="3"
          type="primary"
          size="large"
          style={{ float: "right" }}
          onClick={() => props.changeStep(GAPANALYSIS)}
        >
          {intl.gapBtn[props.language]}
          <Icon type="arrow-right" />
        </Button>
      );
      break;
    case "profile":
      button = (
        <Button
          disabled={!Object.keys(props.drivers).length}
          key="3"
          type="primary"
          size="large"
          style={{ float: "right" }}
          onClick={() => props.changeStep(DRIVERS)}
        >
          {intl.driverBtn[props.language]}
          <Icon type="arrow-right" />
        </Button>
      );
      break;
      default: 
  }
  
  return (
    <Col md={{ span: 20, offset: 2 }} xs={24}>
      {props.step === REPORT && (
        <Button
          style={{ float: "right" }}
          type="primary"
          size="large"
          onClick={() => props.changeStep(ANALYSIS)}
        >
          {intl.analysisBtn[props.language]}
          <Icon type="arrow-right" />
        </Button>
      )}

      {props.step === ANALYSIS && (
        <div>
          <Button
            style={{ float: "left" }}
            key="2"
            type="primary"
            size="large"
            onClick={() => props.changeStep(REPORT)}
          >
            <Icon type="arrow-left" />
            {intl.reportBtn[props.language]}
          </Button>
          {button}
        </div>
      )}

      {props.step === GAPANALYSIS && (
        <Button
          style={{ float: "left" }}
          type="primary"
          size="large"
          onClick={() => props.changeStep(ANALYSIS)}
        >
          <Icon type="arrow-left" />
          {intl.analysisBtn[props.language]}
        </Button>
      )}

      {props.step === DRIVERS && (
        <Button
          style={{ float: "left" }}
          type="primary"
          size="large"
          onClick={() => props.changeStep(ANALYSIS)}
        >
          <Icon type="arrow-left" />
          {intl.analysisBtn[props.language]}
        </Button>
      )}
    </Col>
  );
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/Navigation.js